// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-o_eR","advertDetailService__price":"c-o_eS"};